import React from 'react'

const Loading = () => {
  return <div className='animated fadeIn pt-3 text-center'>Loading...</div>
}

export default Loading
